<template>
  <div class="bg-white rounded-2xl shadow-md p-6 space-y-4">
    <h2 class="text-lg font-bold">Produits d'assurance</h2>

    <div v-if="businessVerticals.length > 0">
      <Table :columns="columns" :data="businessVerticals">
        <template #merchantCommission="{ row }">
          <FieldSpan :style-to-add="'bg-green-200'" :value="formatPercentage(row.storeFee)" />
        </template>
        <template #thirdPartyActor="{ row }">
          <div v-if="row.thirdPartyActorFees && row.thirdPartyActorFees.length > 0">
            <span v-for="(fee, index) in row.thirdPartyActorFees" :key="fee.thirdPartyActorId">
              {{ fee.thirdPartyActorName }} ({{ formatPercentage(fee.fee) }})
              <span v-if="index < row.thirdPartyActorFees.length - 1">,</span>
            </span>
          </div>
          <p class="font-bold" v-else>—</p>
        </template>
        <template #actions="{ row }">
          <PencilAltIcon class="h-5 cursor-pointer inline-block" @click="editBusinessVertical(row)" />
        </template>
      </Table>
    </div>
    <div v-else class="text-center text-sm text-gray-500 py-4">
      Aucun produit d'assurance n'est ajouté à cette boutique.
    </div>

    <div class="flex justify-end">
      <SecondaryButton @click="addBusinessVertical">Ajouter</SecondaryButton>
    </div>

    <Modal :open="displayModal" @close="displayModal = false">
      <BusinessVerticalForm
        :store="store"
        :businessVertical="selectedBusinessVertical"
        @success="onBusinessVerticalFormSuccess"
      />
    </Modal>

    <div class="flex justify-end gap-x-3 pt-2">
      <SecondaryButton @click="$emit('previous')">Retour</SecondaryButton>
      <SecondaryButton @click="$emit('step-completed')" :disabled="businessVerticals.length === 0">
        Continuer
      </SecondaryButton>
    </div>
  </div>
</template>

<script>
import { PencilAltIcon } from "@heroicons/vue/outline";
import { Modal, SecondaryButton, Table, FieldSpan, toCamelCase, formatPercentage } from "@estaly/ui";
import BusinessVerticalForm from "@/components/store/BusinessVerticalForm.vue";
import { mapActions } from "vuex";

export default {
  name: "StoreOnboardingStepVerticals",
  components: { PencilAltIcon, Modal, SecondaryButton, Table, FieldSpan, BusinessVerticalForm },
  props: { store: { type: Object, required: true } },
  emits: ["step-completed", "previous"],
  data() {
    return {
      businessVerticals: [],
      displayModal: false,
      selectedBusinessVertical: null,
    };
  },
  computed: {
    columns() {
      return [
        { label: this.$t("Vertical"), field: "category" },
        { label: this.$t("Merchant commission"), field: "storeFee", slot: "merchantCommission" },
        { label: this.$t("Insurer"), field: "insurerName" },
        { label: this.$t("Third party actor"), field: "thirdPartyActorFees", slot: "thirdPartyActor" },
        { label: "", field: "actions", slot: "actions" },
      ];
    },
  },
  async mounted() {
    await this.fetchBusinessVerticals();
  },
  methods: {
    ...mapActions("businessVerticals", ["fetch"]),
    formatPercentage,
    async fetchBusinessVerticals() {
      const response = await this.fetch({
        storeId: [this.store.id],
        enabled: true,
        includes: ["third_party_actor_fees"],
      });
      if (!response?.success) return;
      this.businessVerticals = toCamelCase(response.data)?.records || [];
    },
    addBusinessVertical() {
      this.selectedBusinessVertical = null;
      this.displayModal = true;
    },
    editBusinessVertical(bv) {
      this.selectedBusinessVertical = bv;
      this.displayModal = true;
    },
    async onBusinessVerticalFormSuccess() {
      this.displayModal = false;
      await this.fetchBusinessVerticals();
    },
  },
};
</script>
